import React from 'react';
import { Outlet } from 'react-router-dom';

import logo from 'assets/logo.png';
import { EnvironmentBanner } from 'components/EnvironmentBanner';

import styles from './AuthLayout.module.scss';

export const AuthLayout = (): JSX.Element => {

  return (
    <div className={styles.app}>
      <div className={styles['app-container']}>
        <div className={styles.logo}>
          <img alt="SunCentral Logo" src={logo} className="img-fluid" />
        </div>
        <EnvironmentBanner />
        <div className={styles['form-container']}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};
